import { render, staticRenderFns } from "./ModalBox.vue?vue&type=template&id=314a2b7e&"
import script from "./ModalBox.vue?vue&type=script&lang=ts&"
export * from "./ModalBox.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports